/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  DownOutlined,
  FieldTimeOutlined,
  PlusOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Dropdown,
  Menu,
  message,
  Modal,
  Row,
  Tabs,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";
import BotMessages from "../BotQuestions/BotQuestions";
import ExistingTrigger from "../ExistingTrigger/ExistingTrigger";
import ScheduledChannelPost from "../ScheduledMessages/ScheduledChannelPost";
import ScheduledMessagesTable from "../ScheduledMessages/ScheduledMessagesTable";
import SendDM from "../SendDM/SendDM";
import SurveyResultsTab from "../SurveyResultsTab/SurveyResultsTab.tsx";
import TrackTrigger from "../TrackTrigger/TrackTrigger";
import TriggerTemplate from "../TriggerTemplate/TriggerTemplate";

const { TabPane } = Tabs;

const modalStyle = { top: 40, right: 10 };

const teamId = localStorage.getItem("team-id");
const slackId = localStorage.getItem("slack-id");

const Triggers = () => {
  const supabase = getSupaClient();
  const [userSettings, setUserSettings] = useState({});
  const [selectedTrigger, setSelectedTrigger] = useState(null);
  const [openTriggerModel, setOpenTriggerModel] = useState(false);
  const [openSurveyModel, setOpenSurveyModel] = useState(false);
  const [isScheduledPostVisible, setScheduledPostVisible] = useState(false);
  const [isDmVisible, setIsDmVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  // const [triggerType, setTriggerType] = useState("team_join");
  // TODO: do this based on step to support multiple messages

  const loadUserSettings = async () => {
    console.log("team id", teamId, slackId);
    // console.log("loading user emojis");
    const { data, error } = await supabase
      .from("users")
      .select("settings, timezone")
      .match({ slack_id: slackId });

    if (error) {
      console.log("Error", error);
      window.analytics.track("User settings load error");
    }
    console.log(error, data);
    if (data && data[0] && data[0].settings) {
      // console.log("data", data[0]);
      // setUserSettings(...userSettingsObj, data[0].settings);
      setUserSettings({ ...data[0].settings, timezone: data[0].timezone });
      // console.log("time", data[0]);
    }
  };

  /**
   * Purpose:
   * Params
   */
  const loadTriggers = async () => {
    setRefresh(!refresh);
  };

  useEffect(() => {
    loadUserSettings();
    loadTriggers();
    document.title = " Automation & Triggers | Dots";
  }, []);

  const showScheduledPost = () => {
    setScheduledPostVisible(true);
  };

  const closeTriggerModal = () => {
    setOpenTriggerModel(false);
  };

  const closeSurveyModal = () => {
    setOpenSurveyModel(false);
  };

  const cancelScheduledPost = () => {
    setScheduledPostVisible(false);
  };

  const showDmModal = () => {
    setIsDmVisible(true);
  };

  const cancelDm = () => {
    setIsDmVisible(false);
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() => {
          setOpenTriggerModel(true);
        }}
      >
        <Tooltip title="Click to add a trigger that sends DMs">
          Trigger DMs
        </Tooltip>
      </Menu.Item>
      <Menu.Item>
        <Tooltip
          title="Click to add a trigger that sends a survey"
          onClick={() => {
            setOpenSurveyModel(true);
          }}
        >
          Trigger survey
        </Tooltip>
      </Menu.Item>
      <Menu.Item key="2" onClick={setIsDmVisible}>
        <Tooltip title="Click to schedule DMs to send">Mass DM</Tooltip>
      </Menu.Item>
      <Menu.Item key="3" onClick={showScheduledPost}>
        <Tooltip title="Click to schedule a channel post">Channel post</Tooltip>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="flex flex-col">
      <Row>
        <Col>
          <Dropdown overlay={menu}>
            <Button type="primary" icon={<PlusOutlined />}>
              New <DownOutlined />
            </Button>
          </Dropdown>
        </Col>
      </Row>
      <div
        style={{
          width: "100%",
          height: "100%",
          minHeight: "50vh",
          textAlign: "center",
        }}
      >
        <Tabs defaultActiveKey="1">
          <TabPane
            key="1"
            tab={
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
              <span>
                <span className="-mt-1">
                  <FieldTimeOutlined />
                </span>
                <span className="-ml-1">Track individual messages</span>
              </span>
            }
            style={{ paddingTop: 20 }}
          >
            <ScheduledMessagesTable />
          </TabPane>
          <TabPane
            key="2"
            style={{ paddingTop: 20 }}
            tab={
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events
              <span>
                <span className="-mt-1">
                  <UnorderedListOutlined />
                </span>
                <span className="-ml-1">Existing triggers</span>
              </span>
            }
          >
            <Card>
              {selectedTrigger ? (
                <TrackTrigger
                  selectedTrigger={selectedTrigger}
                  selectTrigger={setSelectedTrigger}
                />
              ) : (
                <ExistingTrigger
                  refresh={refresh}
                  selectTrigger={setSelectedTrigger}
                />
              )}
            </Card>
          </TabPane>
          <TabPane
            tab={
              <span>
                <span className="-mt-1">
                  <UnorderedListOutlined />
                </span>
                <span className="-ml-1">Survey results</span>
              </span>
            }
            key="/surveys"
            style={{ paddingTop: 20 }}
          >
            <SurveyResultsTab />
          </TabPane>
        </Tabs>
        <Modal
          width={1100}
          title="New trigger"
          style={modalStyle}
          visible={openTriggerModel}
          onCancel={closeTriggerModal}
          footer={[]}
        >
          <TriggerTemplate
            type="new"
            loadTriggers={loadTriggers}
            closeModal={closeTriggerModal}
            userSettings={userSettings}
          />
        </Modal>
        <Modal
          width={1100}
          title="New Survey"
          style={modalStyle}
          visible={openSurveyModel}
          onCancel={closeSurveyModal}
          footer={[]}
        >
          <BotMessages
            type="new"
            loadTriggers={loadTriggers}
            userSettings={userSettings}
            closeModal={closeSurveyModal}
            wasTriggered
          />
        </Modal>
        <Modal
          width={700}
          title="Schedule post"
          style={modalStyle}
          visible={isScheduledPostVisible}
          onCancel={cancelScheduledPost}
          footer={[]}
        >
          <ScheduledChannelPost closeModal={cancelScheduledPost} />
        </Modal>
        <Modal
          width={700}
          title="Schedule DM"
          style={modalStyle}
          visible={isDmVisible}
          onCancel={cancelDm}
          footer={[
            <Button key="submit" onClick={cancelDm}>
              Cancel
            </Button>,
          ]}
        >
          <SendDM closeModal={cancelDm} sendNow />
        </Modal>
      </div>
    </div>
  );
};

export default Triggers;
